module.exports = __webpack_public_path__ + "static/media/home-menu.b47595d9.png";